(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sale-countdown]').forEach(function (bar) {
    var total = Number(bar.dataset.countdownTotal || 0);
    var remaining = total;
    var shouldLoop = bar.dataset.countdownLoop === 'true';
    var hoursEl = bar.querySelector('[data-countdown-hours]');
    var minutesEl = bar.querySelector('[data-countdown-minutes]');
    var secondsEl = bar.querySelector('[data-countdown-seconds]');

    if (!hoursEl || !minutesEl || !secondsEl || total <= 0) {
      return;
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function render() {
      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;

      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    render();

    window.setInterval(function () {
      remaining -= 1;

      if (remaining < 0) {
        remaining = shouldLoop ? total : 0;
      }

      render();
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setUpBenefitsStrip(section) {
      if (!section || section.dataset.benefitsReady === "true") return;

      var scroller = section.querySelector("[data-benefits-scroller]");
      var progress = section.querySelector("[data-benefits-progress] span");

      if (!scroller || !progress) return;

      section.dataset.benefitsReady = "true";

      function updateProgress() {
        var scrollable = scroller.scrollWidth - scroller.clientWidth;
        var visible = scroller.scrollWidth > 0 ? scroller.clientWidth / scroller.scrollWidth : 1;
        var handleWidth = Math.max(18, Math.min(100, visible * 100));
        var travel = 100 - handleWidth;
        var progressLeft = scrollable > 0 ? scroller.scrollLeft / scrollable * travel : 0;

        progress.style.width = handleWidth + "%";
        progress.style.left = progressLeft + "%";
        progress.style.transform = "none";
      }

      scroller.addEventListener("scroll", updateProgress, { passive: true });
      window.addEventListener("resize", updateProgress);
      updateProgress();
    }

    function initBenefitsStrips(root) {
      root.querySelectorAll("[data-benefits-strip]").forEach(setUpBenefitsStrip);
    }

    initBenefitsStrips(document);

    document.addEventListener("shopify:section:load", function (event) {
      initBenefitsStrips(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"]) return;
  try {
    
  (() => {
    const initFaq = (root) => {
      if (!root || root.dataset.faqInitialized === 'true') return;
      root.dataset.faqInitialized = 'true';

      const search = root.querySelector('[data-faq-search]');
      const filters = Array.from(root.querySelectorAll('[data-faq-filter]'));
      const items = Array.from(root.querySelectorAll('[data-faq-item]'));
      const empty = root.querySelector('[data-faq-empty]');
      let activeCategory = 'all';

      // Cache the searchable text once. Reading textContent on every keystroke
      // forces a layout pass per item, which is noticeable on long lists.
      const haystacks = new Map(
        items.map((item) => [item, (item.textContent || '').toLocaleLowerCase()])
      );

      const update = () => {
        const query = (search?.value || '').trim().toLocaleLowerCase();
        let visibleCount = 0;

        items.forEach((item) => {
          const categoryMatches = activeCategory === 'all' || item.dataset.category === activeCategory;
          const queryMatches = !query || (haystacks.get(item) || '').includes(query);
          const visible = categoryMatches && queryMatches;
          item.hidden = !visible;
          if (!visible) item.open = false;
          if (visible) visibleCount += 1;
        });

        if (empty) empty.hidden = visibleCount !== 0;
      };

      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          activeCategory = filter.dataset.faqFilter || 'all';
          filters.forEach((button) => {
            const selected = button === filter;
            button.classList.toggle('is-active', selected);
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          update();
        });
      });

      search?.addEventListener('input', update);
      search?.addEventListener('search', update);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-store-faq]').forEach(initFaq);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
